import React from 'react';
import { BookOpenText, ShieldCheck, Users, Zap } from 'lucide-react';
import './FeaturesSection.css';

type FeatureItem = {
  title: string;
  description: string;
  icon: React.ComponentType<{ size?: number; strokeWidth?: number }>;
  iconClassName: string;
};

const featureItems: FeatureItem[] = [
  {
    title: 'Zengin İçerik',
    description: 'Farklı branş ve sınıf seviyelerine uygun binlerce dökümana erişin.',
    icon: BookOpenText,
    iconClassName: 'new-site-features-section-icon-rich',
  },
  {
    title: 'Güvenilir Kaynak',
    description: 'Kontrol edilmiş ve düzenli olarak güncellenen içerikler.',
    icon: ShieldCheck,
    iconClassName: 'new-site-features-section-icon-trust',
  },
  {
    title: 'Öğretmen Topluluğu',
    description: 'Fikir alışverişinde bulunun, deneyimlerinizi paylaşın.',
    icon: Users,
    iconClassName: 'new-site-features-section-icon-community',
  },
  {
    title: 'Kolay ve Hızlı',
    description: 'Aradığınız dökümana kolayca ulaşın, zamandan tasarruf edin.',
    icon: Zap,
    iconClassName: 'new-site-features-section-icon-speed',
  },
];

function FeaturesSection() {
  return (
    <section className="new-site-features-section-root" aria-label="Öne çıkan özellikler">
      <div className="new-site-features-section-grid">
        {featureItems.map((feature) => {
          const IconComponent = feature.icon;

          return (
            <article key={feature.title} className="new-site-features-section-card">
              <span
                className={`new-site-features-section-icon-wrap ${feature.iconClassName}`}
                aria-hidden="true"
              >
                <IconComponent size={18} strokeWidth={2.2} />
              </span>

              <h2 className="new-site-features-section-card-title">{feature.title}</h2>
              <p className="new-site-features-section-card-text">{feature.description}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default FeaturesSection;